import { Component,Input, Output, OnInit, EventEmitter } from '@angular/core';
import { ProfileModel } from 'src/app/models/profile.model';
import { ProductModel } from 'src/app/models/product.model';
import { DataService } from 'src/app/services/data/data.service';
import { NavController, AlertController } from '@ionic/angular';
import { FileService } from 'src/app/services/file/file.service';
import { Observable } from 'rxjs';
import { ContextService } from "src/app/services/context/context.service";
import { Camera,CameraResultType } from '@capacitor/camera';


@Component({
  selector: 'photo-uploader',
  templateUrl: './photo-uploader.component.html',
  styleUrls: ['./photo-uploader.component.scss'],
})
export class PhotoUploaderComponent implements OnInit {

  @Output() photoChanged = new EventEmitter<any>();

  uploadProgress: Observable<number>;
  uploadedFileURL: Observable<string>;
  @Input()
  isUploading=false;

  @Input()
  isUploaded=false;

  fileSize: number;
  @Input()
  file: any;
  @Input()
  img: any;

  @Input()
  item:any;

  @Input()
  canChangePhoto = true;

  constructor(private dataService:DataService,
    public contextService:ContextService) {

  }

  ngOnInit(){
  }

  public onFileChange(event) {
    if (event.target.files && event.target.files.length) {
      this.file = event.target.files[0];
      this.photoChanged.emit(this.file);
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.img = event.target.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  async editPhoto() {
    if(this.contextService.onMobileOS){
      try {
        const cameraResult = await Camera.getPhoto({
          quality: 90,
          allowEditing: false,
          resultType: CameraResultType.Uri,
        });
        this.file = await fetch(cameraResult.webPath).then(r => r.blob());
        this.photoChanged.emit(this.file);
        this.img = cameraResult.webPath;
      } catch (error) {
        console.error(error);
      }
    }
  }
}
